import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import Div from "@jumbo/shared/Div";
import { Button, MenuItem } from "@mui/material";
import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { makeFormikYupValidator } from "app/utils/validation";
import { DSOK_MENU_TYPES } from "app/utils/constants/settings";

const MenuForm = ({ menu, onAddMenu, onEditMenu, onCancel }) => {
  const { t } = useTranslation();
  // Menu code = menuType of its categories (QR ordering reads code "QR"). Offer the known
  // types; when editing a menu whose code is outside the list, keep it as an option so it
  // is not lost.
  const codeOptions = Array.from(
    new Set([...DSOK_MENU_TYPES, ...(menu?.code ? [menu.code] : [])])
  );
  const MenuSchema = Yup.object().shape({
    title: Yup.string(),
    code: Yup.string(),
  });
  const validate = makeFormikYupValidator(MenuSchema, (missing) => {
    alert(
      `${t("messages.checkRequiredFields")}\n` +
        missing.map((p) => `• ${p}`).join("\n")
    );
  });

  return (
    <Formik
      validateOnChange={true}
      initialValues={menu || { title: "", code: "" }}
      validate={validate}
      onSubmit={async (data) => {
        const handler = menu ? onEditMenu : onAddMenu;
        handler(data);
      }}
    >
      {(props) => (
        <Form style={{ textAlign: "left" }} noValidate>
          <Div sx={{ mt: 2, mb: 1, mx: 2 }}>
            <JumboTextField
              fullWidth
              name="title"
              label={t("sidebar.menuItem.title")}
            />
          </Div>
          <Div sx={{ mt: 2, mb: 1, mx: 2 }}>
            <JumboTextField
              select
              fullWidth
              name="code"
              label={t("sidebar.menuItem.code")}
            >
              {codeOptions.map((code) => (
                <MenuItem key={code} value={code}>
                  {code}
                </MenuItem>
              ))}
            </JumboTextField>
          </Div>
          <Div
            sx={{
              mt: 2,
              mb: 1,
              mx: 2,
              gap: "4px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button size="normal" onClick={onCancel}>
              {t("buttons.cancel")}
            </Button>
            <Button type="submit" variant="contained" size="normal">
              {t("buttons.ok")}
            </Button>
          </Div>
        </Form>
      )}
    </Formik>
  );
};

export default MenuForm;
